<template>
  <v-container fluid class="container--style">
    <div>
      <v-snackbar class="new-alert" v-model="alert" :timeout="timeout" :color="alertType" top="top">
        {{this.alertMessage}}
        <v-icon color="white" flat @click="alert = false">close</v-icon>
      </v-snackbar>
    </div>
    <v-layout justify-end>
      <v-flex md12 lg12 xs12 sm12 xl12>
        <v-btn
          style="margin-top:3%"
          :disabled="(nEtapa==6 && this.$session.getAll().userType == 'postgrado')"
          color="#ec6a12"
          @click="edit = true"
        >{{button}}</v-btn>
        <v-btn
          style="margin-top:3%"
          v-if="this.$session.getAll().userType == 'postgradodca'"
          color="#394049"
          @click="openAprobacion"
        >Aprobación DCA</v-btn>
        <v-btn
          style="margin-top:3%"
          v-if="nEtapa==6 && this.$session.getAll().userType == 'prorrector'"
          color="#394049"
          @click="aprobacionProPlan = true"
        >Aprobación Plan de mejoramiento</v-btn>

        <!-- <v-btn
          style="margin-top:3%"
          v-if="this.$session.getAll().userType == 'vipo' && this.nEtapa==5"
          color="#394049"
          @click="openAprobacionVipo"
        >Aprobación VIPO</v-btn>-->
        <v-btn
          style="margin-top:3%"
          v-if="this.$session.getAll().userType == 'prorrector' && this.etapa.etapa5Dca && this.nEtapa==6"
          color="#394049"
          @click="openAprobacionProrrector"
        >Aprobación Prorrector</v-btn>

        <v-btn style="margin-top:3%" color="#394049" fab dark small @click="video = true">
          <v-icon dark>video_library</v-icon>
        </v-btn>

        <v-card
          v-for="(anexo,index) in anexos"
          :key="index"
          class="comentario v-card-new"
          color="grey"
          dark
        >
          <v-card-title class="color">
            <v-layout>
              <v-chip>
                <v-avatar>
                  <v-icon dark>account_circle</v-icon>
                </v-avatar>
                {{anexo.nombreVisible}}
              </v-chip>
            </v-layout>
            <v-layout justify-end>
              <v-btn
                fab
                small
                color="#EC6A12"
                v-on:click="downloadFile(anexo.path,anexo.nombre,false)"
              >
                <v-icon color="#394049" dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                fab
                :disabled="$session.getAll().userType == 'postgrado'"
                small
                color="#EC6A12"
                v-on:click="getAnexoABorrar(anexo)"
              >
                <v-icon color="#394049" dark>delete</v-icon>
              </v-btn>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="edit" width="700px" persistent>
      <template v-slot:activator="{ on }"></template>
      <v-card class="new-card">
        <v-card-title>
          <span class="headline">{{button}}</span>
        </v-card-title>
        <v-layout align-center justify-center>
          <v-flex md9 lg9 xs9 sm9>
            <v-layout>
              <v-flex md12 lg12 xs12 sm12>
                <label class="left" for="sel1">Nombre de Archivo</label>
                <select class="form-control" id="5" v-model="nombreArchivo">
                  <option selected disabled>-Selecciona una opción-</option>
                  <option v-for="(nombre,index) in nombres" :key="index" :value="nombre">{{nombre}}</option>
                </select>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-text-field
                color="#EB7704"
                label="Cargar documento"
                @click="pickFile()"
                v-model="FileName"
                prepend-icon="attach_file"
                :disabled="disabled"
              ></v-text-field>
              <input
                color="#EB7704"
                type="file"
                id="file"
                ref="myFiles"
                style="display: none"
                @change="previewFiles()"
              />
            </v-layout>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#ec6a12" flat="flat" @click="edit = false">Cerrar</v-btn>
          <v-btn color="#394049" flat="flat" @click="submitFile()">Subir Archivo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="eliminar" width="500">
      <template v-slot:activator="{ on }"></template>
      <v-card>
        <v-card-title>
          <span class="headline">¿Está seguro de querer eliminar el archivo {{anexo.nombreVisible}}?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#ec6a12" flat="flat" @click="eliminar = false">No, cancelar</v-btn>
          <v-btn color="#394049" flat="flat" @click="erase(anexo.id)">Sí, eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-dialog v-model="aprobacion" width="500">
          <template v-slot:activator="{ on }"></template>
          <v-card class="v-card-dialog">
            <v-card-title v-if="create">
              <span class="headline">{{this.pregunta}}</span>
            </v-card-title>
            <v-card-title v-if="!create">
              <span class="headline">Estado de aprobación</span>
            </v-card-title>
            <v-layout>
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <label for="usr">Observación</label>
                <textarea
                  v-model="obsEtapa"
                  type="text"
                  rows="3"
                  class="form-control"
                  id="usr"
                  :disabled="this.$session.getAll().userType != 'postgradodca'"
                />
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#ec6a12" flat="flat" @click="aprobacion = false">Cerrar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgradodca'"
                color="red"
                flat="flat"
                @click="checkPro(false)"
              >desaprobar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgradodca'"
                color="#394049"
                flat="flat"
                @click="checkPro(true)"
              >aprobar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-dialog v-model="aprobacionVipo" width="500">
          <template v-slot:activator="{ on }"></template>
          <v-card class="v-card-dialog">
            <v-card-title v-if="create">
              <span class="headline">¿Desea aprobar la etapa?</span>
            </v-card-title>
            <v-layout>
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <label for="usr">Observación</label>
                <textarea
                  v-model="obsEtapaVipo"
                  type="text"
                  rows="3"
                  class="form-control"
                  id="usr"
                  :disabled="this.$session.getAll().userType != 'vipo'"
                />
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#ec6a12" flat="flat" @click="aprobacionVipo = false">Cerrar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'vipo'"
                color="red"
                flat="flat"
                @click="checkVipo(false)"
              >desaprobar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'vipo'"
                color="#394049"
                flat="flat"
                @click="checkVipo(true)"
              >aprobar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-dialog v-model="aprobacionPro" width="500">
          <template v-slot:activator="{ on }"></template>
          <v-card class="v-card-dialog">
            <v-card-title v-if="create">
              <span class="headline">{{this.preguntapro}}</span>
            </v-card-title>
            <v-layout>
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <label for="usr">Observación</label>
                <textarea
                  v-model="obsEtapaPro"
                  type="text"
                  rows="3"
                  class="form-control"
                  id="usr"
                  :disabled="this.$session.getAll().userType != 'prorrector'"
                />
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#ec6a12" flat="flat" @click="aprobacionPro = false">Cerrar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'prorrector'"
                color="red"
                flat="flat"
                @click="checkProrrector(false)"
              >desaprobar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'prorrector'"
                color="#394049"
                flat="flat"
                @click="checkProrrector(true)"
              >aprobar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-dialog v-model="aprobacionProPlan" width="500">
          <template v-slot:activator="{ on }"></template>
          <v-card class="v-card-dialog">
            <v-card-title>
              <span class="headline">¿Desea aprobar el Plan de mejoramiento?</span>
            </v-card-title>
            <v-layout>
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <label for="usr">Observación</label>
                <textarea
                  v-model="obsEtapaProPlan"
                  type="text"
                  rows="3"
                  class="form-control"
                  id="usr"
                  :disabled="this.$session.getAll().userType != 'prorrector'"
                />
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#ec6a12" flat="flat" @click="aprobacionProPlan = false">Cerrar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'prorrector'"
                color="red"
                flat="flat"
                @click="checkProrrectorPlan(false)"
              >desaprobar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'prorrector'"
                color="#394049"
                flat="flat"
                @click="checkProrrectorPlan(true)"
              >aprobar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-dialog v-model="video" width="1000">
        <template v-slot:activator="{ on }"></template>
        <v-toolbar dark color="#eb7704">
          <v-btn icon dark @click="pauseVideo()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card class="v-card-dialog">
          <video controls id="myVideo">
            <source :src="video1" type="video/mp4" />
          </video>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>


<script>
import video1 from "../../../assets/video1.mp4";
import video5 from "../../../assets/video5.mp4";
import video6 from "../../../assets/video6.mp4";
import video7 from "../../../assets/video7.mp4";
export default {
  data() {
    return {
      pregunta: "¿Desea aprobar la etapa?",
      preguntapro: "¿Desea aprobar la etapa?",
      video1: "",
      video: false,
      nEtapa: "",
      etapa: "",
      create: "",
      aprobacion: "",
      obsEtapa: "",
      obsEtapaVipo: "",
      aprobacionVipo: "",
      obsEtapaPro: "",
      obsEtapaProPlan: "",
      aprobacionPro: "",
      aprobacionProPlan: false,
      eliminar: false,
      anexo: {},
      nombreArchivo: "",
      button: "Agregar Documentación Obligatoria",
      nombres: [],
      edit: false,
      content: "this.$route.params.id",
      anexos: [],
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      alertType: "",
      alertMessage: "",
      alert: false,
      timeout: 4000,
      docExiste: false,
      idDoc: "",
      path: "",
      disabled: false,
      file: "",
      fileToUpload: "",
      FileName: "",
      path1: "",
      path2: ""
    };
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      this.verificaPath();
    }
  },
  created() {
    //console.log(this.$route.fullPath);
    this.verificaPath();
  },

  methods: {
    openAprobacion() {
      this.aprobacion = true;
      this.create = true;
    },

    openAprobacionVipo() {
      this.aprobacionVipo = true;
      this.create = true;
    },

    openAprobacionProrrector() {
      this.aprobacionPro = true;
      this.create = true;
    },

    checkProrrectorPlan(booleanValue) {
      //console.log(this.obsEtapaProPlan)
      this.aprobacionProPlan = false;
      this.etapa["etapa7Dca"] = booleanValue;
      this.etapa["comentarioEtapa7"] = this.obsEtapaProPlan;
      var tipo = "";
      if (booleanValue) {
        tipo = "aprobada";
      } else {
        tipo = "desaprobada";
      }
      //console.log(this.nEtapa);
      axios
        .patch(
          process.env.ROOT_API + "/etapa/updateEtapaDca?etapaNum=" + 7,
          this.etapa,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.verificaPath();
          alert("Plan de mejoramiento ha sido " + tipo);
        })
        .catch(error => {
          console.error(error);
          this.verificaPath();
          alert("Error:" + error);
        });
    },

    checkProrrector(booleanValue) {
      this.aprobacionPro = false;
      this.etapa["comentarioEtapa" + this.nEtapa + "Gral"] = this.obsEtapaPro;
      this.etapa["etapa" + this.nEtapa + "Otro"] = booleanValue;
      var tipo = "";
      if (booleanValue) {
        tipo = "aprobada";
      } else {
        tipo = "desaprobada";
      }
      //console.log(this.nEtapa);
      axios
        .patch(
          process.env.ROOT_API +
            "/etapa/updateEtapaGral?etapaNum=" +
            this.nEtapa,
          this.etapa,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.verificaPath();
          alert("Etapa " + this.nEtapa + " ha sido " + tipo);
        })
        .catch(error => {
          console.error(error);
          this.verificaPath();
          alert("Error:" + error);
        });
    },

    checkVipo(booleanValue) {
      this.aprobacionVipo = false;
      this.etapa["comentarioEtapa" + this.nEtapa + "Gral"] = this.obsEtapaVipo;
      this.etapa["etapa" + this.nEtapa + "Otro"] = booleanValue;
      var tipo = "";
      if (booleanValue) {
        tipo = "aprobada";
      } else {
        tipo = "desaprobada";
      }
      //console.log(this.nEtapa);
      axios
        .patch(
          process.env.ROOT_API +
            "/etapa/updateEtapaGral?etapaNum=" +
            this.nEtapa,
          this.etapa,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.verificaPath();
          alert("Etapa " + this.nEtapa + " ha sido " + tipo);
        })
        .catch(error => {
          console.error(error);
          this.verificaPath();
          alert("Error:" + error);
        });
    },

    checkPro(booleanValue) {
      this.aprobacion = false;
      this.etapa["comentarioEtapa" + this.nEtapa] = this.obsEtapa;
      this.etapa["etapa" + this.nEtapa + "Dca"] = booleanValue;
      var tipo = "";
      if (booleanValue) {
        tipo = "aprobada";
      } else {
        tipo = "desaprobada";
      }
      //console.log(this.nEtapa);
      axios
        .patch(
          process.env.ROOT_API +
            "/etapa/updateEtapaDca?etapaNum=" +
            this.nEtapa,
          this.etapa,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.verificaPath();
          alert("Etapa " + this.nEtapa + " ha sido " + tipo);
        })
        .catch(error => {
          console.error(error);
          this.verificaPath();
          alert("Error:" + error);
        });
    },
    getAnexoABorrar(item) {
      this.anexo = item;
      this.eliminar = true;
    },
    erase(id) {
      axios
        .delete(
          process.env.ROOT_API + "/documento/eraseDoc?idCap=" + id,
          this.auth
        )
        .then(response => {
          this.anexos = response.data;
          this.eliminar = false;
          alert(response.data);
          this.getAnexos();
        })
        .catch(error => {
          alert(error.response.data);
        });
    },
    verificaPath() {
      if (this.$route.fullPath == "/documentos/basicos") {
        this.nEtapa = 1;
        this.video1 = video1;
        this.nombres = [
          "Resolución creación del Programa",
          "Normas Internas y Plan de Estudios del Programa",
          "Acuerdo de acreditación"
        ];
        this.path1 =
          "/documento/getByTipo?tipo=InfoBasica&idPostgrado=" +
          this.$session.getAll().ccData.id;
        this.path2 =
          "/documento/createDoc?idPostgrado=" +
          this.$session.getAll().ccData.id +
          "&tipo=InfoBasica&nombre=";
        this.button = "Agregar Información Básica";
      }
      if (this.$route.fullPath == "/documentosFinales/anexosObligatorios") {
        this.nEtapa = 7;
        this.video1 = video7;
        this.nombres = [
          "Anexo N° 1: Resolución de creación del programa y sus modificaciones",
          "Anexo N° 2: Reglamentos vigentes de funcionamiento del programa",
          "Anexo N° 3: Normativa institucional respecto de los programas de postgrado.",
          "Anexo N° 4: Documentos de acreditación (si corresponde)",
          "Anexo N° 5: Programas de Asignaturas (en formato CNA)",
          "Anexo N° 6: Fichas de Tesis o Actividad Formativa Equivalente",
          "Anexo N° 7: Fichas Académicas",
          "Anexo N° 8: Convenios vigentes y formalizados",
          "Anexo N° 9: Informes Ejecutivos de Resultados de Proyectos Institucionales (si corresponde)",
          "Anexo N° 10: Origen Disciplinar (más de 30 matriculados)",
          "Informe de Autoevaluación",
          "Formulario de Antecedentes"
        ];
        this.path1 =
          "/documento/getByTipo?tipo=AnexoObligatorio&idPostgrado=" +
          this.$session.getAll().ccData.id;
        this.path2 =
          "/documento/createDoc?idPostgrado=" +
          this.$session.getAll().ccData.id +
          "&tipo=AnexoObligatorio&nombre=";
        this.button = "Agregar Documentación Obligatoria";
      }

      if (this.$route.fullPath == "/documentos45/anexosObligatorios45") {
        this.nEtapa = 5;
        this.video1 = video5;
        this.nombres = [
          "Resolución de creación del programa y sus modificaciones",
          "Documentos de acreditación (si corresponde)",
          "Programas de asignaturas en formato UNIE",
          "Fichas Académicas en formato DCA",
          "Convenios vigentes y formalizados",
          "Ficha de Investigación en formato DCA",
          "Ficha de Vinculación con el Medio en formato DCA"
        ];
        this.path1 =
          "/documento/getByTipo?tipo=AnexoObligatorio4&idPostgrado=" +
          this.$session.getAll().ccData.id;
        this.path2 =
          "/documento/createDoc?idPostgrado=" +
          this.$session.getAll().ccData.id +
          "&tipo=AnexoObligatorio4&nombre=";
        this.button = "Agregar Documentación Obligatoria";
      }
      /*

      if (this.$route.fullPath == "/documentosEtapa5/anexosObligatorios5") {
        this.nEtapa = 5;
        this.nombres = [
          "Informe Comisión de Evaluación de Programa de Postgrado (CEPP)"
        ];
        this.path1 =
          "/documento/getByTipo?tipo=AnexoObligatorio5&idPostgrado=" +
          this.$session.getAll().ccData.id;
        this.path2 =
          "/documento/createDoc?idPostgrado=" +
          this.$session.getAll().ccData.id +
          "&tipo=AnexoObligatorio5&nombre=";
        this.button = "Acta Comisión de Evaluación de Programas de Postgrado (CEPP)";
      }
      if (this.$route.fullPath == "/documentosEtapa5/docsAutoevaluacion5") {
        this.nEtapa = 5;
        this.nombres = [
          "Anexo N° 1: Resolución de creación del programa y sus modificaciones",
          "Anexo N° 2: Reglamentos vigentes de funcionamiento del programa",
          "Anexo N° 3: Normativa institucional respecto de los programas de postgrado.",
          "Anexo N° 4: Documentos de acreditación (si corresponde)",
          "Anexo N° 5: Programas de Asignaturas (en formato CNA)",
          "Anexo N° 6: Fichas de Tesis o Actividad Formativa Equivalente",
          "Anexo N° 7: Fichas Académicas",
          "Anexo N° 8: Convenios vigentes y formalizados",
          "Anexo N° 9: Informes Ejecutivos de Resultados de Proyectos Institucionales (si corresponde)",
          "Anexo N° 10: Origen Disciplinar (más de 30 matriculados)",
          "Informe de Autoevaluación",
          "Formulario de Antecedentes"
        ];
        this.path1 =
          "/documento/getByTipo?tipo=Autoevaluacion5&idPostgrado=" +
          this.$session.getAll().ccData.id;
        this.path2 =
          "/documento/createDoc?idPostgrado=" +
          this.$session.getAll().ccData.id +
          "&tipo=Autoevaluacion5&nombre=";
        this.button = "Agregar Documentación Autoevaluacion";
      }*/

      if (this.$route.fullPath == "/documentosActa/acta") {
        this.nEtapa = 6;
        this.video1 = video6;
        this.nombres = ["Acta de reunión"];
        this.path1 =
          "/documento/getByTipo?tipo=Acta&idPostgrado=" +
          this.$session.getAll().ccData.id;
        this.path2 =
          "/documento/createDoc?idPostgrado=" +
          this.$session.getAll().ccData.id +
          "&tipo=Acta&nombre=";
        this.button = "Agregar Acta";
        this.preguntapro = "¿Desea aprobar el proceso de autoevaluación?";
        this.pregunta = "¿Desea aprobar el proceso de autoevaluación ?";
      }
      this.getAnexos();
    },

    getAnexos() {
      axios
        .get(process.env.ROOT_API + this.path1, this.auth)
        .then(response => {
          //console.log("ANEXOS");
          //console.log(response.data);
          this.anexos = response.data;
          //console.log(this.anexos);
        })
        .catch(error => {
          //console.log("ERROR ANEXOS");
          console.error(error);
          this.showAlert("error", error.response.data);
        })
        .then(response => {
          axios
            .get(
              process.env.ROOT_API +
                "/etapa/etapaUsuario?idPostgrado=" +
                this.$session.getAll().ccData.id,
              this.auth
            )
            .then(response => {
              //console.log("ANEXOS");
              //console.log(response.data);
              this.obsEtapa = response.data["comentarioEtapa" + this.nEtapa];
              this.obsEtapaVipo =
                response.data["comentarioEtapa" + this.nEtapa + "Gral"];
              this.obsEtapaPro =
                response.data["comentarioEtapa" + this.nEtapa + "Gral"];
              this.obsEtapaProPlan =
                response.data["comentarioEtapa7"];
              this.etapa = response.data;
            })
            .catch(error => {
              //console.log("ERROR ANEXOS");
              console.error(error);
              this.showAlert("error", error.response.data);
            });
        });
    },

    pickFile() {
      //console.log("entrando a pick file");
      //console.log(this.$refs["myFiles"]);
      this.$refs["myFiles"].click();
    },
    previewFiles() {
      //console.log(index);
      this.fileToUpload = this.$refs["myFiles"].files[0];
      //console.log(this.$refs["myFiles"].files);
      //console.log(this.filess);
      this.FileName = this.$refs["myFiles"].files[0].name;
    },
    submitFile() {
      let formData = new FormData();
      var name = this.nombreArchivo;
      var email = this.$session.getAll().email;
      //console.log("indice: " + index);

      formData.append("file", this.fileToUpload);
      //console.log("FORM DATA");
      //console.log(formData);
      axios
        .post(
          process.env.ROOT_API + this.path2 + this.nombreArchivo,
          formData,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          //console.log("SUCCESS!!");
          //console.log(response.data);
          //this.path = response.data;
          //this.filesDge.dge[index]["saved"] = "si";
          //this.filesDge.dge[index]["path"] = response.data[0];
          //this.filesDge.dge[index]["name"] = response.data[1];
          alert(
            "Archivo: " + response.data.nombre + " fue cargado exitosamente."
          );
          this.getAnexos();
          this.FileName = "";
          this.edit = false;
          //No fuerza la recarga
          //this.$router.push({path: `/capitulo/${this.$route.params.id}/informacion`})
        })
        .catch(error => {
          //console.log("FAILURE!!");
          //console.log(error.response.data);
          alert(error.response.data);
        });
    },

    downloadFile(pathFile, nameFile, view) {
      var pathCorrecto = this.convertPath(pathFile);
      //console.log(pathFile);
      //console.log("Descargando archivo ....");
      //console.log(nameFile);
      axios
        .get(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/downloadFile?dir=" +
            pathCorrecto,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          if (view) {
            this.forceFileDownload2(response, nameFile);
          } else {
            this.forceFileDownload(response, nameFile);
          }
        })
        .catch(error => {
          console.error(error);
        });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },

    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    forceFileDownload2(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      window.open(url, "_blank");
    },
    showAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.alert = true;
    },
    pauseVideo() {
      document.getElementById("myVideo").pause();
      this.video = false;
    }
  }
};
</script>

<style scoped>
.new-card {
  height: auto;
}

.new-alert {
  width: auto;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}

.v-card__title.color {
  font-size: 12px;
  padding: 5px;
}

.v-card__text {
  background-color: #474a4e;
  padding: 1%;
  text-align: justify;
}
.comentario {
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 2%;
  margin-bottom: 2%;
  border-radius: 5%;
}

.container--style {
  padding: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

#myVideo {
  width: 100%;
  height: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/dca/documentosPost/AnexosO.vue